import { render, staticRenderFns } from "./SistemaEstomatogmatico.vue?vue&type=template&id=494621da"
import script from "./SistemaEstomatogmatico.vue?vue&type=script&lang=js"
export * from "./SistemaEstomatogmatico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports